export enum OpenTofuMigrationTile {
  ReadyToMigrate = "ReadyToMigrate",
  Queue = "Queue",
}
